<template>
  <v-container
    grid-list-md
    fluid
    class="pa-2"
  >
    <v-layout
      row
      wrap
    >
      <v-container
        grid-list-md
        fluid
        class="pa-1"
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            sm6
          >
            <v-card class="booking max-shadow">
              <v-card-title class="pa-4">
                <div class="title-2">
                  Bookings
                </div>
                <v-spacer />
              </v-card-title>
              <v-divider />
              <v-card-text class="px-1">
                <v-layout
                  v-if="bookings.length === 0"
                  row
                  wrap
                >
                  <span
                    style="margin: 0 auto"
                    class="grey--text"
                  >
                    There are no facility bookings to show
                  </span>
                </v-layout>
                <div
                  v-for="booking in bookings"
                  :key="booking.id"
                >
                  <v-flex xs12>
                    <booking-tile
                      v-ripple
                      style="cursor: pointer"
                      :class="`active_${booking.id}`"
                      :booking="booking"
                      @click="openBooking(booking)"
                    />
                  </v-flex>
                </div>
                <v-layout
                  row
                  wrap
                  justify-center
                >
                  <v-btn
                    v-if="bookings.length !== 0 && bookings.length % 10 === 0"
                    color="primary"
                    flat
                    center
                    :loading="loadMoreLoading"
                    @click="loadMorebookings"
                  >
                    load more
                  </v-btn>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex
            xs12
            sm6
          >
            <booking
              :booking="selectedBooking"
            /> 
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <v-snackbar
      v-model="snackbar"
      :right="true"
      :timeout="4000"
      :top="true"
      :color="snackColor"
    >
      {{ snackText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { firestore } from '@/firebase';
import * as moment from 'moment';
import BookingTile from './BookingTile';
import Booking from './Booking';
import _get from 'lodash/get';

export default {
  name: 'HelpDesk',
  components: {
    booking: Booking,
    'booking-tile': BookingTile
  },
  data() {
    return {
      bookings: [],
      selectedBooking: {},
      commentText: '',
      loadMoreLoading: false,
      commentLoading: false,
      limit: 10,
      dateFormat: 'DD MMM YYYY',
      lastSelectedBookingId: '',
      snackbar: false,
      snackColor: 'success',
      snackText: ''
    };
  },
  computed: {
    status() {
      return this.selectedBooking.closed ? 'Closed' : 'Open';
    },
    changeStatusBtnText() {
      return this.selectedBooking.closed ? 'Reopen' : 'close';
    },
    createdAt() {
      const date = _get(this.selectedBooking, 'createdAt');
      if (date !== undefined)
        return moment(date.toDate()).format(this.dateFormat);
      return '';
    },
    role() {
      return _get(this.$store.state.profile, 'role');
    },
    cid() {
      return _get(this.$store.state.profile, 'cid');
    },
    bookingsRef() {
      return this.role === 'admin'
        ? firestore
            .collection('facilityBookings')
            .orderBy('bookedDate', 'desc')
            .where('facility.cid', '==', this.cid)
            .where('facility.private', '==', true)
        : firestore
            .collection('facilityBookings')
            .orderBy('bookedDate', 'desc')
            .where('facility.private', '==', false);
    }
  },
  created() {
    this.$store.commit('setToolbarTitle', { toolbarTitle: 'Meeting Rooms' });
  },
  mounted() {
    this.fetchBookings();
  },
  methods: {
    fetchBookings() {
      this.bookingsRef
        .limit(this.limit)
        .get()
        .then(bookings => {
          const docs = [];
          bookings.forEach(docSnapshot => {
            docs.push({ ...docSnapshot.data(), ...{ id: docSnapshot.id } });
          });
          this.bookings = docs;
          if (docs.length === 0) return (this.selectedBooking = {});
          this.selectedBooking = docs[0];
          this.$nextTick().then(() => {
            const list = document.getElementsByClassName(
              `active_${this.selectedBooking.id}`
            )[0];
            list.classList.add('blue', 'lighten-5');
            this.lastSelectedBookingId = docs[0].id;
            if (this.loadMoreLoading) this.loadMoreLoading = false;
          });
        });
    },
    openBooking(booking) {
      this.selectedBooking = booking;
      if (this.lastSelectedBookingId) {
        document
          .getElementsByClassName(`active_${this.lastSelectedBookingId}`)[0]
          .classList.remove('blue', 'lighten-5');
        const list = document.getElementsByClassName(`active_${booking.id}`)[0];
        list.classList.add('blue', 'lighten-5');
        this.lastSelectedBookingId = booking.id;
      }
    },
    formatDate(timestamp) {
      const date = timestamp.toDate();
      return moment(date).format(this.dateFormat);
    },

    _toArray(obj) {
      if (!obj) return [];
      return Object.keys(obj).map(key => {
        const item = obj[key];
        item.id = key;
        return item;
      });
    },

    loadMorebookings() {
      this.limit = this.limit * 2;
      this.loadMoreLoading = true;
      this.fetchBookings();
    }
  }
};
</script>

<style scoped>
.booking {
  height: calc(100vh - var(--toolbar-height)) !important;
  overflow-y: scroll;
}
</style>